<div class="textarea-wrapper">
  @if (label) {
  <label class="textarea-label" [for]="textareaId">
    {{ label }}
    @if (required) {
    <span class="required-indicator">*</span>
    }
  </label>
  }

  <div class="textarea-container" [class.has-error]="hasError">
    <textarea
      #textareaElement
      [id]="textareaId"
      class="textarea-field"
      [placeholder]="placeholder"
      [value]="value"
      [disabled]="disabled"
      [required]="required"
      [rows]="rows"
      (input)="onInput($event)"
      (blur)="onBlur()"
      [attr.aria-label]="label || placeholder"
      [attr.aria-required]="required"
      [attr.aria-invalid]="hasError"
    ></textarea>
  </div>

  @if (hasError) {
  <span class="textarea-error" role="alert">
    {{ errorText }}
  </span>
  }
</div>

